module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    staticClass: "label-form"
  }, [_vm._v(_vm._s(_vm.labelText))]), _vm._v(" "), _c('v-select', _vm._b({
    staticClass: "filter-select filter-select filter-select-autocomplete",
    attrs: {
      "hide-details": "",
      "value": _vm.value,
      "single-line": ""
    },
    on: {
      "input": _vm.sendValue,
      "change": _vm.changeValue
    }
  }, 'v-select', _vm.$attrs, false))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f72537a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/clerkinn/shared/select-button.vue
// module id = 924
// module chunks = 1 2 3 4 5 20 23 26 27 47